import { BlogPostListingInterface } from 'common/types/entities/BlogPostListingInterface'
import { LatestBlogPostsInterface } from 'common/types/entities/LatestBlogPostsInterface'
import { CustomFontProperties } from 'common/utils/fontsUtils'

export function getNewBlogPostListingFontProperties(
  entity: BlogPostListingInterface | LatestBlogPostsInterface,
) {
  const fontProperties = []

  if (entity.titleFontFamily) {
    fontProperties.push({
      fontFamily: entity.titleFontFamily,
      fontStyle: entity.titleFontStyle,
      fontWeight: entity.titleFontWeight,
    })
  }
  if (entity.mobileTitleFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileTitleFontFamily,
      fontStyle: entity.mobileTitleFontStyle,
      fontWeight: entity.mobileTitleFontWeight,
    })
  }
  if (entity.categoriesFontFamily) {
    fontProperties.push({
      fontFamily: entity.categoriesFontFamily,
      fontWeight: entity.categoriesFontWeight,
      fontStyle: entity.categoriesFontStyle,
    })
  }
  if (entity.mobileCategoriesFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileCategoriesFontFamily,
      fontWeight: entity.mobileCategoriesFontWeight,
      fontStyle: entity.mobileCategoriesFontStyle,
    })
  }
  if (entity.descriptionFontFamily) {
    fontProperties.push({
      fontFamily: entity.descriptionFontFamily,
      fontWeight: entity.descriptionFontWeight,
      fontStyle: entity.descriptionFontStyle,
    })
  }
  if (entity.mobileDescriptionFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileDescriptionFontFamily,
      fontWeight: entity.mobileDescriptionFontWeight,
      fontStyle: entity.mobileDescriptionFontStyle,
    })
  }
  if (entity.dateFontFamily) {
    fontProperties.push({
      fontFamily: entity.dateFontFamily,
      fontWeight: entity.dateFontWeight,
      fontStyle: entity.dateFontStyle,
    })
  }
  if (entity.mobileDateFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileDateFontFamily,
      fontWeight: entity.mobileDateFontWeight,
      fontStyle: entity.mobileDateFontStyle,
    })
  }
  return fontProperties
}

export function getNewBlogPostListingCustomFontProperties(
  entity: BlogPostListingInterface | LatestBlogPostsInterface,
) {
  const fontProperties: CustomFontProperties[] = []

  if (entity.titleFontFamily && entity.titleFontFileId) {
    fontProperties.push({
      fontFamily: entity.titleFontFamily,
      fontFileId: entity.titleFontFileId,
    })
  }
  if (entity.mobileTitleFontFamily && entity.mobileTitleFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileTitleFontFamily,
      fontFileId: entity.mobileTitleFontFileId,
    })
  }
  if (entity.categoriesFontFamily && entity.categoriesFontFileId) {
    fontProperties.push({
      fontFamily: entity.categoriesFontFamily,
      fontFileId: entity.categoriesFontFileId,
    })
  }
  if (entity.mobileCategoriesFontFamily && entity.mobileCategoriesFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileCategoriesFontFamily,
      fontFileId: entity.mobileCategoriesFontFileId,
    })
  }
  if (entity.descriptionFontFamily && entity.descriptionFontFileId) {
    fontProperties.push({
      fontFamily: entity.descriptionFontFamily,
      fontFileId: entity.descriptionFontFileId,
    })
  }
  if (
    entity.mobileDescriptionFontFamily &&
    entity.mobileDescriptionFontFileId
  ) {
    fontProperties.push({
      fontFamily: entity.mobileDescriptionFontFamily,
      fontFileId: entity.mobileDescriptionFontFileId,
    })
  }
  if (entity.dateFontFamily && entity.dateFontFileId) {
    fontProperties.push({
      fontFamily: entity.dateFontFamily,
      fontFileId: entity.dateFontFileId,
    })
  }
  if (entity.mobileDateFontFamily && entity.mobileDateFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileDateFontFamily,
      fontFileId: entity.mobileDateFontFileId,
    })
  }
  return fontProperties
}
